import { useState } from "react";
import type { FrameData } from "@/lib/frame-data";

import { useFrameRenderer } from "../shared/frame-renderer-context";
import { ConversationArtifactMenu } from "./conversation-artifact-menu";

export function ConversationFrameActions({
  frameId,
  frame,
}: {
  frameId: string;
  frame: FrameData;
}) {
  const [artifactOpen, setArtifactOpen] = useState(false);
  const { focused } = useFrameRenderer().useChromeState(frameId);
  if (focused) return null;
  return (
    <div
      className="nodrag nowheel flex shrink-0 items-center justify-end gap-1 px-3 pb-1 pt-3 empty:hidden"
      data-testid="conversation-frame-actions"
      onPointerDown={(event) => event.stopPropagation()}
    >
      <ConversationArtifactMenu
        conversationFrameId={frameId}
        frame={frame}
        open={artifactOpen}
        onOpenChange={setArtifactOpen}
        testIdFrameId={frameId}
        hideWhenEmpty
      />
    </div>
  );
}
